<template>
	<div>
		<v-snackbar
			v-model="snackbar"
			:timeout="10000"
			:top="true"
			color="accent"
			class="black--text"
		>
			{{ snackbarText }}
			<v-btn class="blexon-button" small icon @click="snackbar = false">
				<v-icon>close</v-icon>
			</v-btn>
		</v-snackbar>
		<v-progress-linear v-show="dataLoading" color="accent" indeterminate></v-progress-linear>
		<v-container class="content" grid-list-md fluid>
			<v-layout row align-center class="mb-3">
				<v-flex shrink>
					<h1>Produktionsübersicht</h1>
				</v-flex>
			</v-layout>
			<div v-for="region in overviewByRegion" :key="region.regionId">
				<hr style="margin-top: 2em" />
				<h2 class="mb-2">{{ region.name }}</h2>
				<v-card class="mb-4">
					<v-card-text>
						<table class="v-datatable v-table theme--light overview-table" style="width: 100%">
							<thead>
								<tr>
									<th class="text-xs-left col-fertiger">Fertiger</th>
									<th
										v-for="type in workstepTypes"
										:key="type.value"
										class="text-xs-center col-type"
										:class="{ 'col-type-all': anyHaveWorkstepType(region.fertigers, type.value) }"
									>
										{{ type.label }}
									</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="item in region.fertigers" :key="item.fertigerId">
									<td class="col-fertiger">
										<div style="display: flex; flex-direction: column; align-items: flex-start; gap: 4px; padding-top: 8px">
											<img
												:src="getFertigerLogo(item.fertigerId)"
												style="height: 24px"
												onerror="this.style.display='none'"
											/>
											<span>{{ item.name }}</span>
										</div>
									</td>
									<td
										v-for="type in workstepTypes"
										:key="type.value"
										class="text-xs-center col-type"
									>
										<v-icon v-if="hasWorkstepType(item, type.value)" color="success" small>
											check
										</v-icon>
									</td>
								</tr>
							</tbody>
						</table>
					</v-card-text>
				</v-card>
			</div>
			<p v-if="overviewByRegion.length === 0 && !dataLoading" class="grey--text">
				Keine Daten vorhanden.
			</p>
		</v-container>
	</div>
</template>
<script>
import httpClient from "../store/httpClient";

export default {
	data() {
		return {
			snackbar: false,
			snackbarText: "",
			dataLoading: false,
			overview: [],
			workstepTypes: [
				{ value: 10, label: "NC-Erzeugung" },
				{ value: 20, label: "Laserschneiden" },
				{ value: 30, label: "Kombibearbeitung" },
				{ value: 35, label: "Teilevereinzelung" },
				{ value: 40, label: "Entgraten" },
				{ value: 50, label: "Webern" },
				{ value: 60, label: "Trowalisieren" },
				{ value: 65, label: "Einpressungen" },
				{ value: 70, label: "Abkanten" },
				{ value: 80, label: "Schweissen" },
				{ value: 90, label: "Pulverbeschichten" },
				{ value: 100, label: "Feuerverzinken" },
				{ value: 110, label: "Galv. Verzinken" },
			],
		};
	},
	computed: {
		overviewByRegion() {
			const regionName = (id) => {
				if (id === 1) return "Schweiz";
				if (id === 2) return "Deutschland";
				if (id === 3) return "Österreich";
				return "Unbekannt";
			};
			const groups = {};
			for (const item of this.overview) {
				if (!groups[item.regionId]) {
					groups[item.regionId] = { regionId: item.regionId, name: regionName(item.regionId), fertigers: [] };
				}
				groups[item.regionId].fertigers.push(item);
			}
			return Object.values(groups).sort((a, b) => a.regionId - b.regionId);
		},
	},
	async created() {
		await this.loadOverview();
	},
	methods: {
		async loadOverview() {
			try {
				this.dataLoading = true;
				const response = await httpClient().get("api/Fertiger/GetManufacturingOverview");
				this.overview = response.data;
			} catch (err) {
				this.setSnackbarText("Fehler beim Laden der Produktionsübersicht: " + err);
			} finally {
				this.dataLoading = false;
			}
		},

		hasWorkstepType(item, value) {
			return item.workstepTypes && item.workstepTypes.includes(value);
		},

		anyHaveWorkstepType(fertigers, value) {
			return fertigers.some((f) => this.hasWorkstepType(f, value));
		},

		getFertigerLogo(fertigerId) {
			return `${process.env.VUE_APP_SERVER_URL}api/fertiger/getlogo?fertigerId=${fertigerId}`;
		},

		setSnackbarText(text) {
			this.snackbarText = text;
			this.snackbar = true;
		},
	},
};
</script>
<style scoped>
.overview-table td,
.overview-table th {
	border-right: 1px solid rgba(0, 0, 0, 0.08);
}
.overview-table td:last-child,
.overview-table th:last-child {
	border-right: none;
}
.col-fertiger {
	min-width: 200px;
}
.col-type {
	min-width: 80px;
	font-size: 0.75em;
	padding: 0 8px;
}
.col-type-all {
	background-color: #efbb20 !important;
	color: #000 !important;
	font-weight: bold;
}
</style>
